import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "reactstrap";
import Cookies from "js-cookie";

import { isCampaignVideo, numString, updateTab } from "../utilities";
import { toggelAddProductModal } from "./GlobalParams/GlobalParamsActions";
import GenerateBreadCrumbs from "./GenerateBreadCrumbs";
import PreviousNextButtons from "./PreviousNextButtons";
import {
  toggleAllTranscript,
  transcriptKeywords,
  updateVideoPageState,
} from "../Pages/Video/VideoActions";
import AskVyrillSection from "../Pages/AskVyrill/Components/AskVyrillSection";
import { useLocation, useParams } from "react-router-dom";

import {
  AddProductBtn,
  AddVideosBtn,
  CreateCampaign,
  PublishToAppBtn,
} from "./Components/HeaderButtons";
import { getVideoUploadDetails } from "../Pages/Home/home_actions";
import SingleVideoDownloadDropdown from "./SingleVideoDownloadDropdown";
import CampaignHeader from "../Pages/Video/Components/Campaign/CampaignHeader";
import initialSingleVideo from "../Pages/Video/Components/initialSingleVideo";
import SinglePublish from "../Pages/Video/Components/SinglePublish";
import SinglePublishMessage from "../Pages/Video/Components/SinglePublishMessage";

const Tab = ({ tab, selected, update, count, filters }) => (
  <li
    key={tab}
    className="nav-tab-item"
    onClick={update(updateTab(tab, filters))}
  >
    <div className={`nav-link-${selected ? "active" : "nonactive"}`}>
      <div>
        {tab.includes("Competition")
          ? "Competitors"
          : tab.includes("fan")
          ? "shopper"
          : tab}{" "}
        {selected && (count || count === 0) ? ` (${numString(count)})` : null}
      </div>
      {selected && <div className="nav-link-active-border" />}
    </div>
  </li>
);

const IndexHeader = (props) => {
  const location = useLocation();
  const [openSinglePublish, setOpenSinglePublish] = useState(false);
  const [singleVideo, setSingleVideo] = useState(initialSingleVideo);
  const videoData = useSelector((state) => state.videoData);
  const toggleTranscript = useSelector((state) => state.toggleTranscript);
  const isPublishedPageCategory = useSelector(
    (state) => state.PublishedPageStates.isCategoryPage
  );
  const showCampaignHeader = useSelector(
    (state) => state.videoPageStates.campaignsState.showCampaignHeader
  );

  const isProductCategoryPage = useSelector(
    (state) => state.productPageStates.isCategoryPage
  );
  const isVideoCategoryPage = useSelector(
    (state) => state.videoPageStates.isCategoryPage
  );

  const isPublishedCategoryPage = useSelector(
    (state) => state.PublishedPageStates.isCategoryPage
  );
  const video = useSelector(
    (state) => state.videoAssociations.body.video || {}
  );
  const videoAssociations = useSelector((state) => state.videoAssociations);
  const { body, status } = videoAssociations;

  const dispatch = useDispatch();
  const { id } = useParams();

  const {
    // tabs,
    // currentTab,
    // update,
    // count,
    // csvPath,
    // disabled,
    // filters,
    // openaddYouTubeVideoUrl,
    // videoUrl,
    // roles,
    // page,
    // handleActiveContact,
    // isActiveContact,
    // dates,
    // search,
    // trending,
    // desc,
    filter_page,
    // sort,
    // date,
    // validEmail,
    // vyrillVerified,
    indexName,
    isVideoDetailPage,
    uploadVideoDetails,
    setUploadVideoModal,
    setOpenNewProduct,
    openNewProduct,
    // setOpenSinglePublish,
    // handleOpenSinglePublish,
  } = props;
  const handleOpenSinglePublish = () => {
    dispatch(updateVideoPageState({ openSinglePublish: true }));
    setSingleVideo(body || initialSingleVideo);
  };

  const handleCloseSinglePublish = () => {
    dispatch(updateVideoPageState({ openSinglePublish: false }));
    setSingleVideo(initialSingleVideo);
  };
  useEffect(() => {
    if (toggleTranscript) {
      dispatch(toggleAllTranscript(false));
    }
    dispatch(transcriptKeywords(true));
  }, [filter_page, videoData.count]);

  useEffect(() => {
    getVideoUploadDetails({});
  }, []);

  // const trackShortcutAddVideos = () => {
  //   mixpanel.track(MIXPANEL_HOME_PAGE.SHORTCUT_ADD_VIDEOS);
  // };
  const inputCommonProps = { hidden: true, readOnly: true };

  return (
    <>
      <div
        // style={isVideoDetailPage ? { marginBottom: "0px" } : {}}
        className={`${
          isVideoDetailPage ? "video-details-main-header" : "main-header"
        }`}
      >
        <GenerateBreadCrumbs indexName={indexName} />
        <div className="ask-vyrill-header">
          <AskVyrillSection renderFrom={indexName} />
        </div>

        {indexName == "Products" && isProductCategoryPage && (
          <div>
            <AddProductBtn
              setOpenNewProduct={setOpenNewProduct}
              openNewProduct={openNewProduct}
            />
          </div>
        )}

        {indexName == "Videos" && isVideoCategoryPage && !id && (
          <div className="d-flex gap-1">
            <AddVideosBtn
              uploadVideoDetails={uploadVideoDetails}
              setUploadVideoModal={setUploadVideoModal}
            />
            {/* <CreateCampaign /> */}
          </div>
        )}
        {indexName == "Published" && isPublishedCategoryPage && (
          <div style={{ width: "225px" }} />
        )}

        {/* {indexName == "Videos" && id && isVideoDetailPage && (
          <PublishToAppBtn
            setOpenSinglePublish={setOpenSinglePublish}
            handleOpenSinglePublish={handleOpenSinglePublish}
          />
        )} */}

        {/* <div>s</div> */}
        {/* {console.log(indexName)} */}

        {/* {props.headerElements ? (
          props.headerElements
        ) : (
          <>
            <div>
              <ul className="page-nav-tab mb-0 mt-0">
                {tabs.map((tab) => (
                  <Tab
                    key={tab}
                    tab={tab}
                    count={count}
                    update={update}
                    selected={tab === currentTab}
                    filters={filters}
                    openaddYouTubeVideoUrl={openaddYouTubeVideoUrl}
                    videoUrl={videoUrl}
                    roles={roles}
                    page={page}
                  />
                ))}
              </ul>
            </div>
            <div>
              <div>
                {(roles.includes("brand_manager") ||
                  roles.includes("digital_agency")) &&
                  page === "influencers" && (
                    <Button.Ripple
                      color="primary"
                      className={`button ${
                        isActiveContact ? "" : "secondary"
                      } me-1`}
                      onClick={handleActiveContact}
                    >
                      Contact Creators
                    </Button.Ripple>
                  )}
                {csvPath === "/jwt_api/influencers" && (
                  <form
                    action={`${process.env.REACT_APP_BASE_URL}/jwt_api/influencers`}
                  >
                    <input
                      name="brand_id"
                      value={Cookies.get("bId") || ""}
                      {...inputCommonProps}
                    />
                    <input
                      name="user_id"
                      value={Cookies.get("uId")}
                      {...inputCommonProps}
                    />
                    <input name="csv" value="true" {...inputCommonProps} />
                    <input
                      name="tab"
                      value={currentTab}
                      {...inputCommonProps}
                    />
                    <input
                      name="filters"
                      value={JSON.stringify(filters)}
                      {...inputCommonProps}
                    />
                    <input
                      name="dates"
                      value={JSON.stringify(dates)}
                      {...inputCommonProps}
                    />
                    <input name="search" value={search} {...inputCommonProps} />
                    <input
                      name="trending"
                      value={trending}
                      {...inputCommonProps}
                    />
                    <input name="desc" value={desc} {...inputCommonProps} />
                    <input
                      name="page"
                      value={filter_page}
                      {...inputCommonProps}
                    />
                    <input name="sort" value={sort} {...inputCommonProps} />
                    <input
                      name="validEmail"
                      value={validEmail}
                      {...inputCommonProps}
                    />
                    <input
                      name="vyrillVerified"
                      value={vyrillVerified}
                      {...inputCommonProps}
                    />
                    <input name="date" value={date} {...inputCommonProps} />
                    <Button.Ripple
                      color="outline-primary"
                      type="submit"
                      disabled={disabled}
                      style={{ lineHeight: "1.2" }}
                    >
                      Download CSV
                    </Button.Ripple>
                  </form>
                )}
              </div>
            </div>
          </>
        )} */}
      </div>
      <div>
        {location.pathname.includes("/campaigns/") && (
          <div className="campaign-details-header">
            <CampaignHeader />
          </div>
        )}
      </div>
      {isVideoDetailPage && (
        <div className="detail-page-pagination">
          <div className="pagination-label">
            <PreviousNextButtons isVideoDetailPage type="video" />
          </div>
          <div className="detail-page-buttons d-flex align-items-center">
            {isCampaignVideo(video?.upload_method) && (
              <SingleVideoDownloadDropdown />
            )}
            {/* <AddVideosBtn
              uploadVideoDetails={uploadVideoDetails}
              setUploadVideoModal={setUploadVideoModal}
            /> */}
            <div style={{ position: "relative" }}>
              <PublishToAppBtn
                setOpenSinglePublish={setOpenSinglePublish}
                handleOpenSinglePublish={handleOpenSinglePublish}
              />
              <SinglePublish
                singleVideo={singleVideo}
                open={openSinglePublish}
                onClose={handleCloseSinglePublish}
                pathname="videos" //@TODO
              />
              <SinglePublishMessage
                isVideoDetailPage={isVideoDetailPage}
                singleVideo={singleVideo}
                onClose={handleCloseSinglePublish}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default IndexHeader;
